<template>
  <layout name="Clean"
    ><div class="link-expired__wrapper">
      <VSystemMessage
        :primaryText="sysMessageTitle"
        :secondaryText="sysMessageSecondaryText"
        :actions="getActions"
      ></VSystemMessage></div
  ></layout>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapActions } from "vuex";
import Layout from "@/layouts/Layout";

//components
import VSystemMessage from "@/components/VSystemMessage";

//mixins
import withNavigate from "@/mixins/withNavigate";
import withToasted from "@/mixins/withToasted";

export default Vue.component("LinkExpired", {
  props: {},
  components: {
    Layout,
    VSystemMessage
  },

  mixins: [withNavigate, withToasted],

  data() {
    return {
      sysMessageTitle: "Sorry",
      sysMessageSecondaryText:
        "Your link expired.\n" +
        "You can resend the email or login with another account.",

      email: "",
      token: ""
    };
  },

  computed: {
    getActions() {
      return [
        {
          label: "Send Again",
          value: "resend",
          type: "primary",
          size: "giant",
          click: () =>
            this.sendOnboardingEmail({
              email: this.email,
              onSuccess: () => this.navigate("/onboarding-email-sent"),
              onError: () => this.errorToast("Something went wrong")
            })
        },
        {
          label: "Log In",
          value: "login",
          type: "primary",
          size: "narrow",
          noBorder: true,
          inverted: true,
          click: () => this.navigate("/login")
        }
      ];
    }
  },

  methods: {
    ...mapActions("auth", ["sendOnboardingEmail"])
  },

  created() {
    const { token, email } = this.$route.query;
    this.email = email;
    this.token = token;
  }
});
</script>

<style lang="scss" scoped>
$ns: "link-expired";
.#{$ns}__wrapper {
  display: flex;
  height: 100%;

  &/deep/.v-system-message__wrapper {
    margin: auto;
  }
}
</style>
